export class LoginClienteFormModel {
    constructor(
        public usuario: string = '',
    ) { }
}